import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const TariffPlans = ({
  size,
  type,
  theme,
  className,
  dataTestId = "tariff-plans-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M6.24454 10.1665H5.05366V7.40662H4.17249V6.47212H5.05366V3.04529H7.44064C7.93389 3.04529 8.35831 3.13656 8.71495 3.3191C9.07159 3.50165 9.34584 3.75783 9.53876 4.08869C9.73064 4.41955 9.82762 4.80642 9.82762 5.2524C9.82762 5.70461 9.72751 6.09252 9.52625 6.41611C9.32499 6.73971 9.03926 6.98553 8.66906 7.15459C8.29887 7.32365 7.86506 7.40766 7.36869 7.40766H6.24663V10.1665H6.24454ZM7.85463 8.2095V9.06778H4.17249V8.2095H7.85463ZM7.011 6.47316C7.3082 6.47316 7.57725 6.43997 7.81918 6.37359C8.06006 6.30721 8.25298 6.1869 8.39585 6.01058C8.53871 5.8353 8.61067 5.58222 8.61067 5.25136C8.61067 4.96925 8.55227 4.73796 8.43547 4.55749C8.31868 4.37702 8.15183 4.24219 7.93701 4.15299C7.7222 4.0638 7.46358 4.02024 7.16325 4.02024H6.24037V6.47212H7.011V6.47316Z" />
    <path d="M6.24454 10.1665H5.05366V7.40662H4.17249V6.47212H5.05366V3.04529H7.44064C7.93389 3.04529 8.35831 3.13656 8.71495 3.3191C9.07159 3.50165 9.34584 3.75783 9.53876 4.08869C9.73064 4.41955 9.82762 4.80642 9.82762 5.2524C9.82762 5.70461 9.72751 6.09252 9.52625 6.41611C9.32499 6.73971 9.03926 6.98553 8.66906 7.15459C8.29887 7.32365 7.86506 7.40766 7.36869 7.40766H6.24663V10.1665H6.24454ZM7.85463 8.2095V9.06778H4.17249V8.2095H7.85463ZM7.011 6.47316C7.3082 6.47316 7.57725 6.43997 7.81918 6.37359C8.06006 6.30721 8.25298 6.1869 8.39585 6.01058C8.53871 5.8353 8.61067 5.58222 8.61067 5.25136C8.61067 4.96925 8.55227 4.73796 8.43547 4.55749C8.31868 4.37702 8.15183 4.24219 7.93701 4.15299C7.7222 4.0638 7.46358 4.02024 7.16325 4.02024H6.24037V6.47212H7.011V6.47316Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.100403 1.56453C0.100403 0.828156 0.697356 0.231201 1.43374 0.231201H12.5663C13.3027 0.231201 13.8997 0.828154 13.8997 1.56453V14.4355C13.8997 15.1719 13.3027 15.7688 12.5663 15.7688H1.43374C0.697358 15.7688 0.100403 15.1719 0.100403 14.4355V1.56453ZM12.5663 1.56453L1.43374 1.56453V14.4355H12.5663V1.56453Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.62222 12.5824C2.62222 12.2142 2.9207 11.9158 3.28889 11.9158H7.47774C7.84593 11.9158 8.14441 12.2142 8.14441 12.5824C8.14441 12.9506 7.84593 13.2491 7.47774 13.2491H3.28889C2.9207 13.2491 2.62222 12.9506 2.62222 12.5824Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.79947 12.5824C9.79947 12.2142 10.0979 11.9158 10.4661 11.9158H10.7111C11.0793 11.9158 11.3778 12.2142 11.3778 12.5824C11.3778 12.9506 11.0793 13.2491 10.7111 13.2491H10.4661C10.0979 13.2491 9.79947 12.9506 9.79947 12.5824Z"
    />
  </SVGIcon>
);
